"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListValue = (function () {
    function ListValue(list, currentPath, currentValue, notFoundText) {
        this._notFoundText = "<undefined>";
        this._list = list;
        this._currentPath = currentPath;
        this.current = currentValue;
        if (notFoundText) {
            this._notFoundText = notFoundText;
        }
    }
    Object.defineProperty(ListValue.prototype, "current", {
        get: function () {
            if (this._index === -1) {
                return undefined;
            }
            return _.get(this._list[this._index], this._currentPath);
        },
        set: function (value) {
            var _this = this;
            this._index = _.findIndex(this._list, function (item) {
                return _.get(item, _this._currentPath) === value;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListValue.prototype, "currentItem", {
        get: function () {
            return this._index !== -1 ? this._list[this._index] : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListValue.prototype, "notFoundText", {
        get: function () {
            return this._notFoundText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListValue.prototype, "list", {
        get: function () {
            return this._list;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListValue.prototype, "currentIndex", {
        get: function () {
            return this._index;
        },
        enumerable: true,
        configurable: true
    });
    ListValue.prototype.toString = function () {
        return _.get(this.currentItem, "name") || this._notFoundText;
    };
    return ListValue;
}());
exports.ListValue = ListValue;
//# sourceMappingURL=ListValue.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/ListValue.js
// module id = 12
// module chunks = 0